module.exports = __webpack_public_path__ + "brand-icons.e8e86d7417f45bf14e99.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brand-icons/brand-icons.woff2?v=0.3.2
// module id = 892
// module chunks = 3